/*
 * @Author: your name
 * @Date: 2020-07-09 14:19:28

 * @LastEditTime: 2021-12-20 15:20:23
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath     : \vue-gaokao-ebook\src\router\map\routers.js
 */
const router = [
    {
        path: '/index',
        name: 'index',
        meta: {
            title: '首页'
        },
        component: function (resolve) {
            require(['VIEWS/index/index'], resolve)
        }
    }, //首页
    {
        path: '/',
        redirect: {
            path: '/tfedu_common/home'
        },
        meta: {
            title: '首页'
        },
        component: function (resolve) {
            require(['VIEWS/home/home'], resolve)
        }
    }, //首页
    {
        path: '/expert',
        name: 'expert',
        meta: {
            title: '专家测评'
        },
        component: function (resolve) {
            require(['VIEWS/expert/expert'], resolve)
        }
    },
    {
        path: '/detail',
        name: 'detail22',
        meta: {
            title: '专家测评'
        },
        component: function (resolve) {
            require(['VIEWS/expert/detail'], resolve)
        }
    },
    {
        path: '/foreword',
        name: 'foreword',
        meta: {
            title: '专家测评'
        },
        component: function (resolve) {
            require(['VIEWS/expert/foreword'], resolve)
        }
    },
    {
        path: '/improve',
        name: 'improve',
        meta: {
            title: '专家测评'
        },
        component: function (resolve) {
            require(['VIEWS/expert/improve'], resolve)
        }
    },
    {
      path: '/client_expert',
      name: 'client_expert',
      meta: {
          title: '专家测评'
      },
      component: function (resolve) {
          require(['VIEWS/expert/client-expert'], resolve)
      }
    },
    {
        path: '/overview',
        name: 'overview',
        meta: {
            title: '专家测评'
        },
        component: function (resolve) {
            require(['VIEWS/expert/overview'], resolve)
        }
      },
    // 通关测试路径
    {
      path: '/client-expert-tgcs',
      name: 'client-expert-tgcs',
      meta: {
          title: '专家测评'
      },
      component: function (resolve) {
          require(['VIEWS/expert/client-expert-tgcs'], resolve)
      }
    },
    {
        path: '/tfedu_common/register',
        name: 'register',
        meta: {
            title: '注册'
        },
        component: function (resolve) {
            require(['VIEWS/register/register'], resolve)
        }
    }, //注册
    {
        path: '/login',
        name: 'login',
        meta: {
            title: '登录'
        },
        component: function (resolve) {
            require(['VIEWS/login/login'], resolve)
        }
    },
    {
      path: '/client_logining',
      name: 'client_logining',
      meta: {
          title: '登录'
      },
      component: function (resolve) {
          require(['VIEWS/client/login'], resolve)
      }
    },
    {
      path: '/client_login_success',
      name: 'client_login_success',
      meta: {
          title: '登录成功'
      },
      component: function (resolve) {
          require(['VIEWS/client/login_success'], resolve)
      }
    },
    {
      path: '/client_registering', // 客户端注册
      name: 'client_registering',
      meta: {
          title: '注册'
      },
      component: function (resolve) {
        require(['@/components/register/index.vue'], resolve)
      }
    },
    {
      path: '/client_register_success',
      name: 'client_register_success',
      meta: {
          title: '注册成功'
      },
      component: function (resolve) {
          require(['VIEWS/client/register_success'], resolve)
      }
    },
    {
      path: '/evaluation_report',
      name: 'evaluation_report',
      meta: {
          title: '测评报告'
      },
      component: function (resolve) {
          require(['VIEWS/client/evaluation_report'], resolve)
      }
    },
    {
      path: '/client_download',
      name: 'client_download',
      meta: {
          title: '软件下载'
      },
      component: function (resolve) {
          require(['VIEWS/client/download'], resolve)
      }
    },
    {
      path: '/client_setting',
      name: 'client_setting',
      meta: {
          title: '账号设置'
      },
      component: function (resolve) {
          require(['VIEWS/client/setting'], resolve)
      }
    },
    {
      path: '/client_vip',
      name: 'client_vip',
      meta: {
          title: '我的已购'
      },
      component: function (resolve) {
          require(['VIEWS/client/vip'], resolve)
      }
    },
    {
        path: '/client_vip_card_active',
        name: 'client_vip_card_active',
        meta: {
            title: '会员卡激活'
        },
        component: function (resolve) {
            require(['VIEWS/client/vip_active_card'], resolve)
        }
      },
     //首页
    {
        path: '/payment',
        name: 'payment',
        meta: {
            title: '支付'
        },
        component: function (resolve) {
            require(['VIEWS/payment/payment'], resolve)
        }
    }, //首页
    // {
    //     path: '/home/exam/placement',
    //     name: 'placement',
    //     meta: {
    //         title: '专家测评 / 摸底考试'
    //     },
    //     component: function (resolve) {
    //         require(['VIEWS/home/exam/placement'], resolve)
    //     }
    // },
    {
        path: '/select_subject',
        name: 'select_subject',
        meta: {
            title: '试卷筛选'
        },
        component: function (resolve) {
            require(['VIEWS/home/select_subject'], resolve)
        }
    }, //上传照片
    {
        path: '/photo_upload/index',
        name: 'photo_upload',
        meta: {
            title: '上传照片'
        },
        //comonent: () => import(['VIEWS/photo_upload/index'])
        component: (resolve) => {
            require(['VIEWS/photo_upload/index'], resolve)
        }
    },
    {
        path: '/paper/list/paper-list',
        name: 'paper-list',
        meta: {
            title: '试卷列表'
        },
        component: function (resolve) {
            require(['VIEWS/paper/list/paper-list'], resolve)
        }
    }, //试卷列表
    {
        path: '/paper/paper',
        name: 'paper',
        meta: {
            title: '试卷'
        },
        component: function (resolve) {
            require(['VIEWS/paper/paper'], resolve)
        }
    }, //试卷 
    {
      path: '/paper/paper_ts',
      name: 'paper',
      meta: {
          title: '试卷'
      },
      component: function (resolve) {
          require(['VIEWS/paper/paper_ts'], resolve)
      }
    }, //试卷 
    {
      path: '/paper/pad_paper',
      name: 'pad_paper',
      meta: {
          title: '试卷'
      },
      component: function (resolve) {
          require(['VIEWS/paper/pad_paper'], resolve)
      }
    }, //试卷 
    {
        path: '/paper_detail',
        name: 'paper_detail',
        meta: {
            title: '试卷详情'
        },
        component: function (resolve) {
            require(['@/views/paper/paper_detail'], resolve)
        }
    }, //试卷详情
    {
        path: '/qrcode',
        name: 'qrcode',
        meta: {
            title: '二维码'
        },
        component: function (resolve) {
            require(['@/components/qr-code/qr-code'], resolve)
        }
    }, //试卷
    {
      path: '/paper_preview',
      name: 'paper_preview',
      meta: {
          title: '试卷预览'
      },
      component: function (resolve) {
          require(['VIEWS/paper/paper_preview'], resolve)
      }
    },
    {
      path: '/paper_video_preview',
      name: 'paper_video_preview',
      meta: {
          title: '专家精讲'
      },
      component: function (resolve) {
          require(['VIEWS/paper/paper_video_preview'], resolve)
      }
    },
    {
        path: '/download',
        name: 'download',
        meta: {
            title: '下载客户端'
        },
        component: function (resolve) {
            require(['@/views/download/download'], resolve)
        }
    }, //试卷
    {
        path: '/register/argeement',
        name: 'argeement',
        meta: {
            title: '用户协议'
        },
        component: function (resolve) {
            require(['@/views/register/agreements'], resolve)
        }
    }, //试卷
    {
        path: '/paper/list/paper-list-base-punning',
        name: 'paper-list-base-punning',
        meta: {
            title: '基础夯实'
        },
        component: function (resolve) {
            require(['VIEWS/paper/list/paper-list-base-punning'], resolve)
        }
    }, //试卷
    {
        path: '/paper/list/paper-list-special-strong',
        name: 'paper-list-special-strong',
        meta: {
            title: '专题强化'
        },
        component: function (resolve) {
            require(['VIEWS/paper/list/paper-list-special-strong'], resolve)
        }
    }, //试卷
    {
      path: '/gift',
      name: 'gift',
      meta: {
          title: '赠品详情'
      },
      component: function (resolve) {
          require(['VIEWS/vip/gift'], resolve)
      }
    },
    {
        path: '/paper/paper_continue_last',
        name: 'paper_continue_last',
        meta: {
            title: '继续上次'
        },
        component: function (resolve) {
            require(['VIEWS/paper/paper_continue_last'], resolve)
        }
    }, //试卷

   
    {
        path: '/tfedu_common',
        name: 'tfedu_common',
        component: function (resolve) {
            require(['@/components/layout/tfedu_common'], resolve)
        },
        children: [
          {
            path: 'buy_members',
            name: 'buy_members',
            meta: {
                title: '购买会员'
            },
            component: function (resolve) {
                require(['VIEWS/vip/buy_members_new'], resolve)
            }
          },
          {
            path: 'buy_members_detail',
            name: 'buy_members_detail',
            meta: {
                title: '购买会员'
            },
            component: function (resolve) {
                require(['VIEWS/vip/buy_members_detail'], resolve)
            }
          },
          {
            path: 'buy_members_detail2',
            name: 'buy_members_detail2',
            meta: {
                title: '购买会员'
            },
            component: function (resolve) {
              require(['VIEWS/vip/buy_members_detail2'], resolve)
            }
          },
          {
            path: 'home',
            name: 'home',
            meta: {
                title: '高考专家测评'
            },
            component: function (resolve) {
                require(['VIEWS/home/home'], resolve)
            }
        }, {
            path: '/tfedu_common/expert',
            name: 'expert',
            meta: {
                title: '专家测评'
            },
            component: function (resolve) {
                require(['VIEWS/expert/expert'], resolve)
            }
        },
        {
            path: '/tfedu_common/detail',
            name: 'detail',
            meta: {
                title: '详情'
            },
            component: function (resolve) {
                require(['VIEWS/expert/detail'], resolve)
            }
        },
        {
            path: 'my_evaluation',
            component: function (resolve) {
                require(['VIEWS/my_personal/my_evaluation/index'], resolve)
            },
            name: 'myEvaluation',
            meta: {
                title: '我的学习'
            },
        },
        {
            path: 'team',
            component: function (resolve) {
                require(['VIEWS/index/index'], resolve)
            },
            name: 'team',
            meta: {
                title: '专家团队'
            },
        },
        // {
        //     path: 'evaluation_record',
        //     component: function (resolve) {
        //         require(['VIEWS/my_personal/evaluation_record/index'], resolve)
        //     },
        //     name: 'evaluationRecord',
        //     meta: {
        //         title: '测评记录'
        //     },
        // },
        {
            path: 'setting',
            component: function (resolve) {
                require(['VIEWS/my_personal/setting/index'], resolve)
            },
            name: 'setting',
            meta: {
                title: '账号设置'
            },
        },
    ]
    },
    {
      path: '/client_wrong_topic',
      component: function (resolve) {
          require(['VIEWS/my_personal/wrong_topic/client_index.vue'], resolve)
      },
      name: 'client_wrong_topic',
      meta: {
          title: '错题本'
      },
    },
    {
      path: '/client_wrong_detail',
      component: function (resolve) {
          require(['VIEWS/my_personal/wrong_topic/client_redotest.vue'], resolve)
      },
      name: 'client_wrong_detail',
      meta: {
          title: '错题详情'
      },
    },
    {
      path: '/my_evaluation',
      component: function (resolve) {
          require(['VIEWS/my_personal/my_evaluation/index'], resolve)
      },
      name: 'myEvaluation',
      meta: {
          title: '我的学习'
      },
    },
    {
      path: '/client_balance',
      component: function (resolve) {
        require(['VIEWS/client/balance.vue'], resolve)
      },
      name: 'client_balance',
      meta: {
        title: '我的余额'
      }
    },
    {
      path: '/wrong_topic',
      component: function (resolve) {
          require(['VIEWS/my_personal/wrong_topic/index'], resolve)
      },
      name: 'wrong_topic',
      meta: {
          title: '专家测评错题本'
      },
    },
    {
      path: '/wrong_detail',
      component: function (resolve) {
          require(['VIEWS/my_personal/wrong_topic/redotest'], resolve)
      },
      name: 'wrong_detail',
      meta: {
          title: '错题详情'
      },
    },
    {
      path: '/report',
      component: function (resolve) {
          require(['VIEWS/report/index'], resolve)
      },
      name: 'report',
      meta: {
          title: '测评报告'
      },
    },
    {
      path: '/report_detail',
      component: function (resolve) {
          require(['VIEWS/report/detail'], resolve)
      },
      name: 'report_detail',
      meta: {
          title: '测评详情'
      },
    },
    {
      path: '/report_history',
      component: function (resolve) {
          require(['VIEWS/report/history'], resolve)
      },
      name: 'report_history',
      meta: {
          title: '测评详情'
      }
    },
    {
        path: '/savesuccess',
        component: function (resolve) {
            require(['VIEWS/client/savesuccess'], resolve)
        },
        name: 'savesuccess',
        meta: {
            title: '保存成功'
        }
    },
    {
        path: '/shopping_mall',
        component: function (resolve) {
            require(['VIEWS/web/shopping/shopping_mall.vue'], resolve)
        },
        name: 'shopping_mall',
        meta: {
            title: '尚壹本官网-高考专家测评系统/北斗学霸高考智能备考'
        }
    },
    {
        path: '/shopping_registering',
        component: function (resolve) {
            require(['@/components/register/index.vue'], resolve)
        },
        name: 'shopping_registering',
        meta: {
            title: '注册'
        }
    },
    {
        path: '/web_login',
        component: function (resolve) {
            require(['VIEWS/web/login.vue'], resolve)
        },
        name: 'web_login',
        meta: {
            title: 'vip登录/注册'
        }
    },
    {
        path: '/web_login_register',
        component: function (resolve) {
            require(['VIEWS/login/login-web.vue'], resolve)
        },
        name: 'web_login_register',
        meta: {
            title: '登录/注册'
        }
    },
    {
        path: '/web_order',
        component: function (resolve) {
            require(['VIEWS/web/order/index.vue'], resolve)
        },
        name: 'web_order',
        meta: {
            title: '我的订单'
        }
    },
    {
        path: '/web_vip_card_active',
        component: function (resolve) {
            require(['VIEWS/web/active/index.vue'], resolve)
        },
        name: 'web_order',
        meta: {
            title: '激活'
        }
    },
    {
        path: '/web',
        meta: {
            title: '我的设置'
        },
        component: function (resolve) {
            require(['VIEWS/web/layout/index.vue'], resolve)
        },
        children: [
          {
            path: 'setting',
            name: 'web_setting',
            component: function (resolve) {
                // require(['VIEWS/web/setting/index.vue'], resolve)
                require(['VIEWS/client/setting'], resolve)
            },
          },
          {
            path: 'purchased',
            name: 'web_purchased',
            component: function (resolve) {
                require(['VIEWS/web/purchased/index.vue'], resolve)
            },
          },
          {
            path: 'coordinator',
            name: 'web_coordinator',
            component: function (resolve) {
                require(['VIEWS/web/coordinator/index.vue'], resolve)
            },
          },
          {
            path: 'vip_card_active',
            name: 'vip_card_active',
            component: function (resolve) {
                require(['VIEWS/web/active/index.vue'], resolve)
            },
          }
        ]
    }
    
]

export default router